const settings = {
  dark: false,
  vuetifySettings: {
    theme: {
      primary: '#468189',
      secondary: '#3E3934',
      accent: '#F05023',
      error: '#FF5252',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FFC107',

      buttonDefaultColor: '#F05023',

      walletTop: '#000000',
      walletBottom: '#000000',

      driversTop: '#F05023',
      driversBottom: '#F05023',

      subscriptionsTop: '#FFF',
      subscriptionsBottom: '#FFF',

      planTop: '#F05023',
      planBottom: '#fc9878',

      subscriptionTop: '#d6d6d6',
      subscriptionBottom: '#ffffff',

      documentTop: '#D9D9D9',
      documentBottom: '#485465',

      RTBIKE: '#21D37F',
      FFBIKE: '#21D37F',
      FFCAR: '#468189',
      RTCAR: '#F05023',

      overviewWalletTop: '#468189',
      overviewWalletBottom: '#779fa5',

      overviewPrepaidTop: '#FFEB34',
      overviewPrepaidBottom: '#FFBA09',

      invoiceTop: '#ffffff',
      invoiceBottom: '#ebebeb',
    },
    iconfont: 'md',
  },
}

export default settings
